import { getAuth, signOut } from "firebase/auth";

const SignOut = () => {
  // return <div>SignOut</div>
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      
    })
    .catch((error) => {
      
    });
};

export default SignOut;
